import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { QuerySortOrder } from "@/common/types/querySortOrder.type"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseAvailableCompanyBranchesProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    pageSize?: number;
  };
  sort?: {
    displayName: QuerySortOrder;
  },
  mapper?: (data: any) => T;
}

export const useAvailableCompanyBranches = <T,>({
  filters: { search = '', page, pageSize = 500 } = {},
  sort = { displayName: QuerySortOrder.Ascending },
  mapper = Mapper.default<T>(),
}: UseAvailableCompanyBranchesProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['availableCompanyBranches', search, page, pageSize, sort.displayName],
    queryFn: () => {
      return privateAxios.get(`/companies/available_branches`, {
        params: {
          page_size: pageSize,
          page,
          search,
          'sort[display_name]': sort.displayName,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
}
